import { useDebugValue } from 'react';
import { CompanyBillingRecord } from 'src/features/companyBilling/companyBilling.types';
import { companyBillingSelectors } from 'src/features/companyBilling/companyBilling.state';
import { useRootState } from 'src/store/hooks/useRootState';

export const useCompanyBilling = (): CompanyBillingRecord[] => {
  const state = useRootState();

  const records = companyBillingSelectors.selectAll(state);

  useDebugValue(records);

  return records;
};

export const useHeadsetSucceededBilling = (): CompanyBillingRecord[] => {
  const state = useRootState();

  const records = companyBillingSelectors.selectAll(state);

  useDebugValue(records);
  return records.filter(r => r.qrCodeSucceeded || r.deskSucceeded || r.paymentSystemSucceeded || r.vipAccessSucceeded);
};
